
      import Inquiry from './inquiry.vue'
      import type { App, Plugin } from 'vue'

      export const InquiryPlugin: Plugin = {
        install(app: App) {
          app.component('Inquiry', Inquiry)
        },
      }
      export { Inquiry }
      